<p-card>
  <ng-template #title>{{ project().name }}</ng-template>
  <ng-template #subtitle>{{ 'projects.card.description' | translate }}</ng-template>
  <div class="card-list-item">
    <div class="card-list-item-icon"><i class="fa-solid fa-ruler"></i></div>
    <div class="item-text">
      <div class="item-title">{{ project().number_measurements ? project().number_measurements : 'N/A' }}</div>
      <div class="item-line">{{ "projects.card.number-measurements" | translate }}</div>
    </div>
  </div>
  <ng-template #footer>
    <div class="flex gap-4 mt-2">
      <button pButton routerLink="/projects/{{ project()._id }}" class="w-1/3">{{ 'button.open' | translate }}</button>
    </div>
  </ng-template>
</p-card>
